export default __webpack_public_path__ + "static/media/fb.4370ac0b.png";